import {Component} from '@angular/core';
import {formatCurrency} from '@angular/common';

export interface ParticipatingAccount {
  accountNumber: string;
  compensationLimit: number;
  includesBalance: string;
  includesCluster: string;
  startDate: string;
  accountHolder: string;
  actualBalance: number;
  restrictedData: boolean;
}

@Component({
             selector: 'app-detail-table',
             templateUrl: './participating-accounts-table.component.html',
             styleUrls: ['../../detail-screen/detail-screen.component.css'],
           })
export class ParticipatingAccountsTableComponent {
  restrictedData: boolean;
  tableColumns: string[];
  tableData: ParticipatingAccount[];
  emptyValuePlaceholder = '-';
  errorText: string;
  showTable: boolean;

  constructor() {
    this.tableColumns = [];
    this.tableData = [];
  }

  getCurrency(data, type: string): string {
    let currency = 'EUR';

    if (data[type]) {
      currency = data[type].currencyCode;
    }

    return currency;
  }
}
